var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "video-thumbnail",
        style: _vm.containerStyle,
        on: { click: _vm.openOverlay },
      },
      [
        _c("video", {
          ref: "previewVideo",
          staticClass: "preview-video",
          attrs: { src: _vm.src },
          on: { loadedmetadata: _vm.onLoadedMetadata },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "play-overlay" }, [
          _c("div", { staticClass: "play-button" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "48",
                  height: "48",
                  viewBox: "0 0 24 24",
                  fill: "white",
                },
              },
              [_c("path", { attrs: { d: "M8 5v14l11-7z" } })]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "video-info",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _vm.duration
              ? _c(
                  "div",
                  {
                    staticClass: "video-duration",
                    attrs: { title: _vm.durationTooltip },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "video-duration-icon",
                        attrs: {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 24 24",
                          fill: "currentColor",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.formatTime(_vm.duration)))]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.timestamp
              ? _c(
                  "div",
                  {
                    staticClass: "video-timestamp-wrap",
                    on: {
                      mouseenter: function ($event) {
                        _vm.showTimestampTooltip = true
                      },
                      mouseleave: function ($event) {
                        _vm.showTimestampTooltip = false
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "video-timestamp" }, [
                      _vm._v(_vm._s(_vm.timestamp)),
                    ]),
                    _vm._v(" "),
                    _vm.showTimestampTooltip && _vm.timestampTooltip
                      ? _c("div", { staticClass: "video-timestamp-tooltip" }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.timestampTooltip) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _vm.showOverlay
      ? _c(
          "div",
          {
            staticClass: "video-overlay",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.closeOverlay.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "overlay-content",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "close-button",
                    on: { click: _vm.closeOverlay },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "white",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { ref: "playerContainer", staticClass: "video-container" },
                  [
                    _c("video", {
                      ref: "videoElement",
                      staticClass: "video-element",
                      attrs: { src: _vm.src, autoplay: "" },
                      on: {
                        loadedmetadata: _vm.onOverlayVideoMetadata,
                        play: _vm.onVideoPlay,
                        pause: _vm.onVideoPause,
                        timeupdate: _vm.onTimeUpdate,
                        ended: _vm.onEnded,
                        click: _vm.togglePlay,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "controls",
                        class: { show: _vm.showControls },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "progress-container",
                            on: {
                              click: _vm.seek,
                              mousedown: _vm.startSeeking,
                              mousemove: _vm.updateHoverTime,
                              mouseleave: _vm.hideHoverTime,
                            },
                          },
                          [
                            _c("div", { staticClass: "progress-bar" }, [
                              _c("div", {
                                staticClass: "progress-filled",
                                style: { width: _vm.progressPercent + "%" },
                              }),
                              _vm._v(" "),
                              _vm.isSeeking && _vm.seekTime !== null
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "hover-time seek-time",
                                      style: {
                                        left: _vm.seekTimePosition + "%",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.formatTime(_vm.seekTime)) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm.hoverTime !== null
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "hover-time",
                                      style: {
                                        left: _vm.hoverTimePosition + "%",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.formatTime(_vm.hoverTime)
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "controls-bottom" }, [
                          _c("div", { staticClass: "controls-left" }, [
                            _c(
                              "button",
                              {
                                staticClass: "control-btn",
                                on: { click: _vm.togglePlay },
                              },
                              [
                                !_vm.isPlaying
                                  ? _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "20",
                                          height: "20",
                                          viewBox: "0 0 24 24",
                                          fill: "white",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: { d: "M8 5v14l11-7z" },
                                        }),
                                      ]
                                    )
                                  : _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "20",
                                          height: "20",
                                          viewBox: "0 0 24 24",
                                          fill: "white",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M6 4h4v16H6V4zm8 0h4v16h-4V4z",
                                          },
                                        }),
                                      ]
                                    ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "control-btn",
                                on: { click: _vm.toggleMute },
                              },
                              [
                                !_vm.isMuted && _vm.volume > 0.5
                                  ? _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "20",
                                          height: "20",
                                          viewBox: "0 0 24 24",
                                          fill: "white",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z",
                                          },
                                        }),
                                      ]
                                    )
                                  : !_vm.isMuted && _vm.volume > 0
                                  ? _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "20",
                                          height: "20",
                                          viewBox: "0 0 24 24",
                                          fill: "white",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M7 9v6h4l5 5V4l-5 5H7z",
                                          },
                                        }),
                                      ]
                                    )
                                  : _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "20",
                                          height: "20",
                                          viewBox: "0 0 24 24",
                                          fill: "white",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z",
                                          },
                                        }),
                                      ]
                                    ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-display" }, [
                              _vm._v(
                                _vm._s(_vm.formatTime(_vm.currentTime)) +
                                  " / " +
                                  _vm._s(_vm.formatTime(_vm.duration))
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "controls-right" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.playbackRate,
                                    expression: "playbackRate",
                                  },
                                ],
                                staticClass: "playback-rate",
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.playbackRate = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    _vm.changePlaybackRate,
                                  ],
                                },
                              },
                              _vm._l(_vm.playbackRates, function (rate) {
                                return _c(
                                  "option",
                                  { key: rate, domProps: { value: rate } },
                                  [_vm._v(_vm._s(rate) + "x")]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "control-btn",
                                on: { click: _vm.toggleFullscreen },
                              },
                              [
                                !_vm.isFullscreen
                                  ? _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "20",
                                          height: "20",
                                          viewBox: "0 0 24 24",
                                          fill: "white",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z",
                                          },
                                        }),
                                      ]
                                    )
                                  : _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "20",
                                          height: "20",
                                          viewBox: "0 0 24 24",
                                          fill: "white",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z",
                                          },
                                        }),
                                      ]
                                    ),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }